import api from "../axios";

export async function getContractStatistics(projectId) {
  const res = await api.get(`contract/contract_statistics/${projectId}/`);
  return res.data;
}

export async function getSubStatusStatistics(projectId, construction_type) {
  const res = await api.get(
    `contract/get_sub_status_statistics/${projectId}/`,
    { params: { construction_type } }
  );
  return res.data;
}

export async function getContractCounts(
  projectId,
  construction_type,
  contract_type
) {
  const res = await api.get(`contract/get_contract_counts/${projectId}/`, {
    params: { construction_type, contract_type },
  });
  return res.data;
}
